import React from 'react';
import styled from 'styled-components';
import { Button } from './Button';
import { Dialog, DialogHeader, DialogTitle, DialogContent, DialogFooter } from './Dialog';

const Message = styled.div`
    opacity: 0.8;
`;

interface ConfirmDialogProps {
    isOpen: boolean;
    title: string;
    message: React.ReactNode;
    confirmText?: string;
    cancelText?: string;
    loadingText?: string;
    onConfirm: () => void;
    onCancel: () => void;
    isLoading?: boolean;
    // Defaults to the destructive styling, which is what most of these guard.
    confirmDanger?: boolean;
}

export function ConfirmDialog({
    isOpen,
    title,
    message,
    confirmText = 'Confirmar',
    cancelText = 'Fechar',
    loadingText = 'Removendo...',
    onConfirm,
    onCancel,
    isLoading = false,
    confirmDanger = true,
}: ConfirmDialogProps) {
    return (
        <Dialog isOpen={isOpen} onClose={onCancel} allowCloseOnOverlay={!isLoading} data-testid="confirm-dialog">
            <DialogHeader>
                <DialogTitle>{title}</DialogTitle>
            </DialogHeader>
            <DialogContent>
                <Message>{message}</Message>
            </DialogContent>
            <DialogFooter>
                <Button onClick={onCancel} disabled={isLoading} data-testid="confirm-dialog-cancel">
                    {cancelText}
                </Button>
                <Button
                    danger={confirmDanger}
                    primary
                    onClick={onConfirm}
                    disabled={isLoading}
                    data-testid="confirm-dialog-confirm"
                >
                    {isLoading ? loadingText : confirmText}
                </Button>
            </DialogFooter>
        </Dialog>
    );
}
